/* oxlint-disable cf-web/no-barrel-file */
import { SearchInput } from './search-input'

export { SearchInput }
export { SearchInputDemo } from './search-input.demo'
